import styled from 'styled-components';

export const AppContainer = styled.div`
  font-family: 'Arial, sans-serif';
  color: #FFD700; /* Gold for text accents */
  background-color: #4B0082; /* Deep Purple background */
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
`;
